import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { pluralize } from 'helpers';
import ReviewGalleryMediaGrid from 'components/reviews/ReviewGalleryMediaGrid';
import css from 'styles/components/productdetail/reviewPhotoGallery.scss';
import { shouldRenderReviewGallery } from 'helpers/ReviewUtils';

const makeBody = (props, { testId }) => {
  const {
    reviewGallery: { reviews, imageCount, videoCount },
    limit, useCarousel, placement, showMediaCount,
    onOpenMediaReview
  } = props;

  const showViewAll = !useCarousel && ((videoCount + imageCount) > limit);

  const imageCountText = `${imageCount} ${pluralize('Image', imageCount)}`;
  const videoCountText = `${videoCount} ${pluralize('Video', videoCount)}`;

  return (
    <div className={css.reviewPhotoGallery}>
      {showMediaCount && <div className={css.imageAndVideoCount} data-test-id={testId('imageAndVideoCount')}>{imageCountText}, {videoCountText}</div>}
      <div className={css.imageAndVideoContainer}>
        <ReviewGalleryMediaGrid
          reviews={reviews}
          isPdp={true}
          onOpenMediaReview={onOpenMediaReview}
          useCarousel={useCarousel}
          limit={limit}
          limitHeight={true}
          placementStyle={(placement === 'aisle') && css.galleryAislePlacement} />
      </div>
      {showViewAll ? (
        <div className={cn(css.viewAllReviews, { [css.center]: placement === 'aisle' })}>
          <button
            type="button"
            onClick={onOpenMediaReview.bind(this, null, null)}
            data-track-action="Product-Page"
            data-track-label="Customer-Feedback"
            data-track-value="Customer-Reviews-Review-Gallery"
            data-test-id={testId('customerReviewGallery')}>
            View All{placement === 'bottom' ? ' Customer Photos and Videos' : ''}
          </button>
        </div>
      ) : null}
    </div>
  );
};

const ReviewPhotoGallery = (props, context) => {
  const { id = null, divClass, includeHr, reviewGallery } = props;
  return shouldRenderReviewGallery(reviewGallery) ? (
    <div id={id} className={divClass}>
      {includeHr && <hr />}
      <h3>Customer Photos and Videos</h3>
      {makeBody(props, context)}
    </div>
  ) : null;
};

ReviewPhotoGallery.defaultProps = {
  reviewGallery: {
    reviews: [],
    imageCount: 0,
    videoCount: 0,
    mediaCount: 0
  },
  limit: 0,
  useCarousel: false
};

ReviewPhotoGallery.propTypes = {
  reviewGallery: PropTypes.shape({
    reviews: PropTypes.array,
    imageCount: PropTypes.number,
    videoCount: PropTypes.number,
    mediaCount: PropTypes.number
  }).isRequired,
  limit: PropTypes.number,
  showMediaCount: PropTypes.bool,
  useCarousel: PropTypes.bool,
  onOpenMediaReview: PropTypes.func.isRequired
};

ReviewPhotoGallery.contextTypes = {
  testId: PropTypes.func.isRequired
};

export default ReviewPhotoGallery;
